import { Box, Button } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { showAddClientDialog } from '../../actions/organization'
import { RootState } from '../../store'
import { createSelector } from '@reduxjs/toolkit'
import AddClient from '../Organization/AddClient'
import { AddNewClientIcon } from '../Svgs'

interface AddNewClientProps {}

const isAddClientDialogOpenSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.showAddClientDialog,
)
const selectedOrganizationSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.selectedOrganization,
)

const AddNewClientComponent: React.FC<AddNewClientProps> = ({}) => {
  const dispatch = useDispatch<any>()
  const isAddClientDialogOpen = useSelector(isAddClientDialogOpenSelector)
  const selectedOrganization = useSelector(selectedOrganizationSelector)

  return (
    <>
      <Button
        disableRipple
        onClick={() => dispatch(showAddClientDialog(true))}
        sx={{
          background: '#E5F0FF',
          borderRadius: '0.4rem',
          width: '100%',
          height: '100%',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          boxSizing: 'border-box',
          gap: '1rem',
          p: '0.75rem',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            borderRadius: '0.4rem',
            boxShadow: '0px 1px 5px 0px #00000040',
            background: '#FFFFFF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 'normal',
          }}
        >
          <AddNewClientIcon color={'#1705E5'} />
        </Box>
      </Button>
      <AddClient
        isOpen={isAddClientDialogOpen}
        handleClose={() => dispatch(showAddClientDialog(false))}
        organization_id={Number(selectedOrganization?.id)}
      />
    </>
  )
}

export default AddNewClientComponent
